(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.hzWish = function (btn, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var K = 'hz_wishlist', h = btn.getAttribute('data-handle'), l = [];
    try { l = JSON.parse(localStorage.getItem(K) || '[]'); } catch (err) {}
    var i = l.indexOf(h);
    if (i >= 0) { l.splice(i, 1); btn.classList.remove('is-wished'); }
    else { l.push(h); btn.classList.add('is-wished'); }
    try { localStorage.setItem(K, JSON.stringify(l)); } catch (err) {}
  };
  (function () {
    function init() {
      var l = [];
      try { l = JSON.parse(localStorage.getItem('hz_wishlist') || '[]'); } catch (err) {}
      document.querySelectorAll('.hz-wish').forEach(function (b) {
        if (l.indexOf(b.getAttribute('data-handle')) >= 0) b.classList.add('is-wished');
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
